var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoItemsAvailableSecondary = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 125,
  height: 129,
  fill: "none",
  viewBox: "0 0 125 129",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M37.294 62c.93 0 1.75-.6 2.029-1.484l3.316-10.535a2.125 2.125 0 0 1 2.029-1.484H116.5a2.12 2.12 0 0 1 2.116 2.316l-5.978 63.542a2.124 2.124 0 0 1-2.117 1.92H40.793a2.123 2.123 0 0 1-2.117-1.923l-4.654-50.038A2.12 2.12 0 0 1 36.139 62z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M.807 76.433a2.113 2.113 0 0 1-.348-2.975l24.588-30.976a2.13 2.13 0 0 1 2.988-.346L81.04 83.99a2.113 2.113 0 0 1 .352 2.967l-24.436 31.042a2.13 2.13 0 0 1-2.992.354z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#455664",
  d: "M34.073 79.474 15.74 54.322l-2.657 3.177 17.005 24.357z",
  style: {
    mixBlendMode: "overlay"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M13.34 51.518a2.113 2.113 0 0 1 .466-2.956L62.59 13.06a2.13 2.13 0 0 1 2.973.465l52.431 71.868a2.113 2.113 0 0 1-.466 2.956l-48.784 35.503a2.13 2.13 0 0 1-2.973-.465z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F9FA",
  d: "M27.758 56.857a1.056 1.056 0 0 0-.246 1.477l1.441 2.01a1.065 1.065 0 0 0 1.484.245l38.675-27.58c.477-.34.588-1.001.246-1.477l-1.44-2.01a1.065 1.065 0 0 0-1.484-.245zM21.938 50.041a1.057 1.057 0 0 0-.245 1.477l1.44 2.01a1.065 1.065 0 0 0 1.485.245l16.287-11.626c.477-.34.587-1.002.246-1.477l-1.441-2.01a1.065 1.065 0 0 0-1.484-.245zM33.76 64.927a1.057 1.057 0 0 0-.247 1.477l1.441 2.01a1.065 1.065 0 0 0 1.484.245l38.675-27.58c.477-.34.588-1.001.246-1.477l-1.44-2.01a1.065 1.065 0 0 0-1.484-.245z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#455664",
  d: "M49.485 75.238 29.556 37.113l-2.923 2.118 20.195 38.125z",
  style: {
    mixBlendMode: "overlay"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M26.028 31.304a2.114 2.114 0 0 1 .884-2.859L80.284.247a2.13 2.13 0 0 1 2.876.884l41.594 78.592a2.114 2.114 0 0 1-.884 2.859L70.498 110.78a2.13 2.13 0 0 1-2.877-.884z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F9FA",
  d: "M39.533 38.64c-.521.268-.725.907-.456 1.426l1.139 2.194c.27.52.911.723 1.433.454L83.88 20.92c.52-.27.724-.908.455-1.427l-1.138-2.194a1.065 1.065 0 0 0-1.433-.454zM34.75 31.065c-.522.27-.725.908-.456 1.427l1.139 2.194c.27.52.911.724 1.433.454l17.787-9.19c.52-.269.724-.907.455-1.426l-1.139-2.195a1.065 1.065 0 0 0-1.433-.454zM44.315 47.48c-.52.27-.724.908-.455 1.427L45 51.102c.27.52.911.723 1.432.454L88.665 29.76c.52-.269.724-.907.455-1.427L87.98 26.14a1.065 1.065 0 0 0-1.433-.454zM49.098 56.482a1.057 1.057 0 0 0-.455 1.427l1.138 2.194c.27.52.912.724 1.433.454l42.232-21.794c.521-.27.725-.908.456-1.427l-1.139-2.194a1.065 1.065 0 0 0-1.433-.454zM54.944 66.543a1.057 1.057 0 0 0-.455 1.427l1.138 2.194c.27.52.911.723 1.433.454l42.232-21.795c.521-.268.725-.907.455-1.426l-1.138-2.195a1.065 1.065 0 0 0-1.433-.454zM60.258 77.663c-.52.269-.725.907-.455 1.427l1.138 2.194c.27.52.912.723 1.433.454l42.232-21.795c.521-.269.725-.907.456-1.426l-1.139-2.195a1.065 1.065 0 0 0-1.433-.454z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M45.42 74.56c.928 0 1.75-.601 2.027-1.484l3.317-10.535a2.125 2.125 0 0 1 2.028-1.484h69.442a2.12 2.12 0 0 1 2.116 2.316l-5.978 63.541a2.123 2.123 0 0 1-2.117 1.921H29.787a2.123 2.123 0 0 1-2.117-1.923l-4.655-50.039a2.12 2.12 0 0 1 2.117-2.313z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 96,
  r: 15,
  fill: "#BFD1F7"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DEE7FA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.041,
  d: "m65.456 96.786 5.428 5.48 11.66-11.772"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoItemsAvailableSecondary);
export default ForwardRef;